module.exports = __webpack_public_path__ + "img/kirke.44d65b0.jpg";